/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_SavedInputs */

const en_admin_footer_badges_saved = /** @type {(inputs: Admin_Footer_Badges_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footer badge updated.`)
};

/**
* | output |
* | --- |
* | "Footer badge updated." |
*
* @param {Admin_Footer_Badges_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_saved = /** @type {((inputs?: Admin_Footer_Badges_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_saved(inputs)
});
export { admin_footer_badges_saved as "admin.footer_badges.saved" }